module.exports = __webpack_public_path__ + "img/logoPlatterIcon.d9f08397.png";